import { AuthActionTypes } from "./constants"
import { User } from "types/auth"

const INIT_STATE = {
  user: {},
  loading: false,
}

type AuthActionType = {
  type: AuthActionTypes.AUTHENTICATE
  payload: {
    actionType?: string
    data?: User | {}
    error?: string
  }
}

type State = {
  user?: User | {}
  loading?: boolean
  value?: boolean
}

const Auth = (state: State = INIT_STATE, action: AuthActionType) => {
  switch (action.type) {
    case AuthActionTypes.AUTHENTICATE:
      return { ...state, user: action.payload }
    default:
      return { ...state }
  }
}

export default Auth
